<div class="modal-header">
  <div class="title">
      <h2 class="modal-title-prefix"><span translate="FAKDOKUMENTIZVOZ.SINGULAR"></span></h2>
  </div>
  <span class="close" (click)="Close()"><span class="fa fa-fw fa-times"></span></span>
</div>
<div class="modal-body">
  <form [formGroup]="formGroup" class="">
    <div class="form-group row">
      <div class="col-md-6">
        <yt-number-input-v3
        name="txtTezinaNeto" 
        [Label]="'FAKDOKUMENTIZVOZ.TEZINANETO.SINGULAR'" 
        [selectOnEntry]="true"
        formControlName="TezinaNeto">
      </yt-number-input-v3>
      </div>
      <div class="col-md-6">
        <yt-dropdown-picklist 
        [ModelName]="'jedinicamere'" 
        [GetName]="'get'" 
        [ModelProperty]="'Oznaka,Naziv'" 
        [OrderBy]="'Naziv'"
        [AllowAddNew]="false" 
        formControlName="TezinaNetoJedinicaMereId" 
        [Label]="'FAKDOKUMENTIZVOZ.TEZINANETOJEDINICAMERE.SINGULAR'">
      </yt-dropdown-picklist>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-md-6">
        <yt-number-input-v3
        name="txtTezinaBruto" 
        [Label]="'FAKDOKUMENTIZVOZ.TEZINABRUTO.SINGULAR'" 
        formControlName="TezinaBruto">
      </yt-number-input-v3>
      </div>
      <div class="col-md-6">
        <yt-dropdown-picklist 
        [ModelName]="'jedinicamere'" 
        [GetName]="'get'" 
        [ModelProperty]="'Oznaka,Naziv'" 
        [OrderBy]="'Naziv'"
        [AllowAddNew]="false" 
        formControlName="TezinaBrutoJedinicaMereId" 
        [Label]="'FAKDOKUMENTIZVOZ.TEZINABRUTOJEDINICAMERE.SINGULAR'">
      </yt-dropdown-picklist>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-md-6">
        <yt-number-input-v3
        name="txtZapremina" 
        [Label]="'FAKDOKUMENTIZVOZ.ZAPREMINA.SINGULAR'" 
        formControlName="Zapremina">
      </yt-number-input-v3>
      </div>
      <div class="col-md-6">
        <yt-dropdown-picklist 
        [ModelName]="'jedinicamere'" 
        [GetName]="'get'" 
        [ModelProperty]="'Oznaka,Naziv'" 
        [OrderBy]="'Naziv'"
        [AllowAddNew]="false" 
        formControlName="ZapreminaJedinicaMereId" 
        [Label]="'FAKDOKUMENTIZVOZ.ZAPREMINAJEDINICAMERE.SINGULAR'">
      </yt-dropdown-picklist>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-md-6">
        <yt-input
        [Type]="'text'"
        name="txtPakovanjeVrsta"
        formControlName="PakovanjeVrsta"
        #focusElement
        [Label]="'FAKDOKUMENTIZVOZ.PAKOVANJEVRSTA.SINGULAR'"
        ngbTooltip="{{'FAKDOKUMENTIZVOZ.PAKOVANJEVRSTA.TOOLTIP' | translate }}"
        placement="bottom">
      </yt-input>
      </div>
      <div class="col-md-6">
        <yt-number-input-v3
        name="txtPakovanjeKolicina" 
        [Label]="'FAKDOKUMENTIZVOZ.PAKOVANJEKOLICINA.SINGULAR'" 
        formControlName="PakovanjeKolicina"
        
        placement="bottom">
      </yt-number-input-v3>
      </div>
    </div>
    <div style="height: 5px; background-color: #bedbea; margin: 15px 0;"></div>
    <div class="row">
      <div class="col-md-6">
          <div class="form-group row">
              <div class="col-md-12">
                  <yt-input 
                      [Type]="'text'" 
                      [Label]="'FAKDOKUMENT.POZICIJA.SINGULAR'"
                      formControlName="Pozicija" 
                      [MaxLength]="100">
                  </yt-input>
              </div>
          </div>
      </div>
      <div class="col-md-6">
          <div class="form-group row">
              <div class="col-md-12">
                  <yt-input 
                  [Type]="'text'" 
                  [Label]="'FAKDOKUMENT.CMR.SINGULAR'"
                  formControlName="Crm" 
                  [MaxLength]="100">
              </yt-input>
              </div>
          </div>
      </div>
  </div>
  <div class="row">
      <div class="col-md-12">
          <div class="form-group row">
              <div class="col-md-12">
                  <yt-multiselect
                  #multiselectComponent
                  [ModelName]="'vozilo'"
                  [GetName]="'get'"
                  [ModelProperty]="'Naziv'"
                  [OrderBy]="'Naziv'"
                  formControlName="VozilaIds"
                  [AllowAddNew]="true" 
                  [Type]="'ID'"
                  [Label]="'FAKDOKUMENT.VOZILA.SINGULAR'"
                  (OnItemSelected)="DajStavkeVozila($event)"
                  (GetItems)="VozilaGetItems($event)"
                  >
                </yt-multiselect>
              </div>
          </div>
      </div>
  </div>
 
      <div class="row">
      <div class="col-md-12">
          <div class="form-group row">
              <div class="col-md-12">
                  <yt-input 
                      [Type]="'text'" 
                      [Label]="'FAKDOKUMENT.VOZAC.SINGULAR'"
                      formControlName="Vozac" 
                      [MaxLength]="250">
                  </yt-input>

              </div>
          </div>
      </div>
  </div>
  <div class="row">
      <div class="col-md-12">
          <div class="form-group row">
              <div class="col-md-12">
                  <yt-text-area [MaxLength]="2000" name="txtNapomenaTransporteri" formControlName="NapomenaTransporteri"
                  [Label]="'FAKDOKUMENT.NAPOMENATRANSPORTERI.SINGULAR'"
                  [Height]="4">
                </yt-text-area>

              </div>
          </div>
      </div>
  </div>

</form>
</div>
<div class="modal-footer">
  <button type="submit" class="btn btn-primary" id="btnSave" (click)="Save()" [disabled]="this.Parameters[14].Value"><span>Sačuvaj</span></button>
  <button type="button" class="btn btn-secondary" id="btnClose" (click)="Close()"><span>Zatvori</span></button>
</div>
